import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

@Component({
  selector: 'app-admin-counter',
  templateUrl: './admin-counter.component.html',
  styleUrls: ['./admin-counter.component.scss']
})
export class AdminCounterComponent implements OnInit {

  searchForm: UntypedFormGroup;
  valueInput = '';
  userConnected: InfosUser;
  title = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  async updateTitle(title: string) {
    this.title = await title;
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.title = this.userConnected.role === 'admin' ? 'Gestion des guichets' : `Guichet du club : ${this.userConnected.club_code}`;
  }

  private initForm(): void {
    if (this.userConnected.role === 'admin') {
      this.searchForm = this.formBuilder.group({
        keyword: ['']
      });
    }
  }
}
